import React, { useState } from 'react';
import { FaRegClock } from 'react-icons/fa';
import '../../../assets/OfferExpirationNotice.css';
import { useStoreState } from 'easy-peasy';

function OfferExpirationNotice() {

  const productSettings = useStoreState(state => state.siteSettingsModel.productSettings);

  const submissionNoteText = productSettings?.AdditionalContent?.SubmissionNoteText;

  return (
    <div className={`offer-expiration-notice offer-expiration-notice--animate`}>
      <span className="offer-expiration-notice__icon" aria-hidden="true">
        <FaRegClock className="offer-expiration-notice__clock" />
      </span>
      <span>{submissionNoteText?.Text || ''}</span>
    </div>
  );
}

export default OfferExpirationNotice;
